import type { SVGProps } from 'react';
const DawnFlagTR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-TR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-TR_svg__a)">
      <path fill="#E92434" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m14.945 8.615-.962 1.188.065-1.539-1.407-.564 1.458-.412.092-1.537.835 1.283 1.465-.385-.941 1.206.812 1.299z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.674 10.947A4.68 4.68 0 0 1 9.953 12.8c-2.604 0-4.715-2.15-4.715-4.8s2.11-4.8 4.715-4.8c1.512 0 2.858.725 3.72 1.853a4.04 4.04 0 0 0-2.41-.786c-2.17 0-3.93 1.671-3.93 3.733s1.76 3.733 3.93 3.733c.908 0 1.745-.293 2.41-.786"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagTR;
